import { router } from '@inertiajs/react'
import { colors } from 'theme'

import { type User } from 'helpers/interfaces'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'

import { RoleSelect } from './RoleSelect'

import { faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type ProfilePopoverContentProps = {
  user: User
}

export const ProfilePopoverContent = ({ user }: ProfilePopoverContentProps) => {
  const fullName = `${user.firstName} ${user.lastName}`

  return (
    <Card
      sx={{
        py: 5,
        px: 4,
        width: 328,
        height: 470,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <img
        src={user.avatar}
        alt={fullName}
        style={{
          width: 100,
          height: 100,
          borderRadius: '100%',
          border: '2px solid #949494',
          marginBottom: 16,
        }}
      />

      <Typography variant="h6">{fullName}</Typography>
      <Typography
        sx={{
          px: 1,
          py: 1,
          fontSize: 18,
          color: colors.tabsColor,
          wordBreak: 'break-word',
          textAlign: 'center',
        }}
      >
        {user.email}
      </Typography>

      <Box sx={{ width: 184, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <RoleSelect user={user} />

        <Button variant="contained" href="/account" fullWidth sx={{ mt: 2, fontSize: 17, height: 60 }}>
          Edit Profile
        </Button>

        <Button
          variant="outlined"
          onClick={() => router.delete('/users/sign_out')}
          fullWidth
          sx={{ mt: 2, fontSize: 17, height: 60, border: 2 }}
          endIcon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}
        >
          Logout
        </Button>
      </Box>
    </Card>
  )
}
